import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import PlansBilled from "./PlansBilled.jsx";
import useSubscriptionAccess from "../../authorization/hooks/useSubscriptionAccess.js";
import "./subscriptionAccess.css";

// The warning can be dismissed, but doing so never enables a restricted operation.
export default function SubscriptionRestriction({ area = "this feature", compact = false }) {
  const accessType = useSelector(state => state.clientFunction?.accessType);
  const { state, expiryDate } = useSubscriptionAccess();
  const [open, setOpen] = useState(false);
  const owner = accessType === "CLIENT_ACCESS";
  return <>
    <section className={`universeSubscriptionRestriction ${compact ? "compact" : ""}`} role="status">
      <span className="universeSubscriptionLock" aria-hidden="true">🔒</span>
      <span className="universeSubscriptionLabel">{state === "unknown" ? "Subscription required" : "Subscription expired"}</span>
      <h2>{owner ? "Renew to continue your business operations" : "Your company's subscription needs attention"}</h2>
      <p>{state === "unknown" ? "An active subscription could not be confirmed for this account." : `Your company's subscription${expiryDate ? ` expired on ${new Date(expiryDate).toLocaleDateString()}` : " has expired"}.`} Access to {area} is paused; your existing business records remain stored.</p>
      <div className="universeSubscriptionActions">
        {owner ? <button type="button" className="universeSubscriptionPrimary" onClick={() => setOpen(true)}>Renew or upgrade plan</button> : <p>Ask your company's account owner to renew the subscription.</p>}
        <Link className="universeSubscriptionSecondary" to={owner ? "/cloud-profile-account/client-account" : "/clients/users/workspace"}>{owner ? "View company account" : "Return to workspace"}</Link>
      </div>
    </section>
    {open && owner && <div className="universeSubscriptionBackdrop"><PlansBilled onClose={() => setOpen(false)} /></div>}
  </>;
}
